<template>
  <div>
    <Header></Header>
    <router-view> </router-view>
    <Footer></Footer>
    <right></right>
  </div>
</template>

<script>
  import Header from './header/header'
  import Footer from './footer/footer'
  import right from "./right/right";
    export default {
      name: "home",
      components: {
        Header,
        Footer,
        right
      },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home.vue